<template>
  <div class="Receiving bj">
    <div class="title">
      <div class="left-actions">
        <div class="top-buttons">
          <el-button
            type="primary"
            icon="el-icon-refresh"
            class="bjsearch"
            @click="Refresh"
          ></el-button>
          <el-button type="primary" @click="setDefault">设置默认分货方式</el-button>
          <el-button type="primary" @click="onImport" class="btnWrap">
            导入
          </el-button>
        </div>
        <p class="tips" v-if="role == 'tdc'">需提前一天设置，默认显示上个供货日的下单客户或者导入客户设置坑位号；</p>
      </div>
      <!-- </div> -->
      <div class="seach">
        <div class="itemInput1">
          供货日期：
          <el-date-picker
            v-model="from.supply_time"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择供货日期"
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <div class="itemInput">
          <el-input
            placeholder="输入客户姓名"
            v-model="from.member_name"
            clearable
          ></el-input>
        </div>
        <div class="itemInput">
          <el-input
            placeholder="输入客户电话"
            v-model="from.member_mobile"
            clearable
          ></el-input>
        </div>
        <div class="itemInput" v-if="role == 'tdc'" style="margin-right: 5px">
          <el-select
            v-model="from.delivery_id"
            filterable
            clearable
            placeholder="请选择自提点"
          >
            <el-option
              :key="item.id"
              v-for="item in arrList"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="itemInput" style="margin-right: 5px">
          <el-select v-model="from.region" clearable placeholder="请选择分区">
            <el-option
              :key="item"
              v-for="item in regionList"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div class="itemInput">
          <el-input
            placeholder="输入用户备注"
            v-model="from.remark"
            clearable
          ></el-input>
        </div>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
          class="btnWrap"
        >
          查询
        </el-button>
        <el-button
          class="btnWrap"
          type="warning"
          icon="el-icon-upload2"
          @click="exportHandle"
          :disabled="!tableData.length || disabledExport"
          >导出</el-button
        >
        <el-button type="primary" class="btnWrap" :disabled="isToday" @click="sort">
          排序
        </el-button>
        <el-button type="primary" @click="resettingHandle" class="btnWrap"
          >重置</el-button
        >
      </div>
    </div>
    <!-- 列表 start -->
    <div class="auto-table-flex">
      <table-list
        v-loading="loading"
        :tableData="tableData"
        :time="from.supply_time"
        :regionList="regionList"
        :isToday="isToday"
        @submit="submit"
        @onEditRemark="onEditRemark"
      ></table-list>
    </div>
    <!-- 列表 end -->

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="from.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新增打印坑位自定义弹窗 start -->
    <print-set
      :dialogVisible="dialogVisible"
      @close="dialogVisible = false"
      @submitHandle="submitHandle"
      :showSetButton="false"
      :supplyTime="from.supply_time"
      ref="printSetRef"
    />
    <!-- 新增打印坑位自定义弹窗 end -->
    <!--  导入坑位号 start -->
    <uploadFiledialog
      ref="uploadFiledialogref"
      @dialogVisibleChange="dialogVisibleChange"
    ></uploadFiledialog>
    <!--  导入坑位号 end -->

    <remarkDialog
      ref="remarkDialogRef"
      @dialogVisibleChange="dialogVisibleChange"
    />
    <sortDialog
      :dialogVisible="sortDialogVisible"
      :supplyTime="from.supply_time"
      :deliveryId="from.delivery_id"
      @close="sortDialogVisible = false"
      @submit="submitHandle"
    />
  </div>
</template>
<script>
import TableList from "./modules/table-list/index";
import { formatDate } from "@/utils/tools/date.js";
import cloneDeep from "lodash/cloneDeep";
import {
  postTakeOrderPlacenoList,
  getTakeOrderPlacenoExport,
  postTakeOrderPlacenoReset,
  postTakeOrderPlacenoRegion,
  getTakeOrderPlacenoSupplyTime,
} from "@/api/customPit.js";
import { downLoadFlowBlob } from "@/utils/tools/base";
import printSet from "../modules/printSet.vue";
import uploadFiledialog from "./modules/uploadFiledialog.vue";
import remarkDialog from "./modules/remarkDialog.vue";
import sortDialog from "./modules/sortDialog.vue";

export default {
  name: "CustomPitLocation",
  components: { TableList, printSet, uploadFiledialog, remarkDialog, sortDialog },
  data() {
    return {
      dialogVisible: false,
      sortDialogVisible: false,
      disabledExport: false,
      loading: false,
      role: sessionStorage.getItem("manageIsdentity"),
      from: {
        region: "", // 选择分区
        remark: "", // 用户姓名备注
        delivery_id: "", //用户自提点ID
        member_name: "", //用户名称
        member_mobile: "", // 用户电话
        supply_time: formatDate(), // 供货时间
        page: 1,
        pageSize: 100,
      },
      formDataClone: {}, // 复制一份 初始化数据
      tableData: [],
      arrList: [],
      total: 0,
      regionList: [], // 分区列表
    };
  },
  computed: {
    isToday() {
      return this.from.supply_time === formatDate();
    },
  },
  created() {
    this.formDataClone = cloneDeep(this.from);
    this.initData();
  },
  methods: {
    async initData() {
      this.postAjaxTakeOrderPlacenoRegion();
      // 城市仓 角色 请求自提点列表
      if (this.role != "delivery") {
        await this.getDeliveryList();
      }
      await this.getSupplyTime();
      this.hqlist();
    },
    /** 获取供货日期 */
    async getSupplyTime() {
      try {
        const res = await getTakeOrderPlacenoSupplyTime();
          this.from.supply_time = res.data.supply_time;
          this.formDataClone = cloneDeep(this.from);
      } catch (error) {
        console.log(error, "getTakeOrderPlacenoSupplyTime");
      }
    },
    // 排序
    sort() {
      if (this.isToday) {
        this.$message.warning("供货日期为当天，不可排序");
        return;
      }
      if (this.role == "tdc" && !this.from.delivery_id) {
        this.$message.warning("请选择自提点");
        return;
      }
      this.sortDialogVisible = true;
    },
    // 导入
    onImport() {
      if (this.isToday) {
        this.$message.warning("因供应商打印标签需显示坑位号，当前供货日不可导入用户坑位数据");
        return;
      }
      this.$refs.uploadFiledialogref.addData(this.from.supply_time, this.from.delivery_id);
    },
    onEditRemark(e) {
      this.$refs.remarkDialogRef.addData(e);
    },
    dialogVisibleChange() {
      this.from.page = 1;
      this.tableData = [];
      this.hqlist();
    },
    // 配置打印类型成功 刷新列表
    submitHandle() {
      this.from.page = 1;
      this.tableData = [];
      this.hqlist();
    },
    // 设置默认分货方式
    setDefault() {
      this.dialogVisible = true;
      this.$refs.printSetRef.onInitData(1);
    },
    /**
     * 获取分区列表
     */
    async postAjaxTakeOrderPlacenoRegion() {
      try {
        const res = await postTakeOrderPlacenoRegion();
        this.regionList = res.data;
      } catch (error) {
        console.log(error, "postTakeOrderPlacenoRegion");
      }
    },
    /* 获取自提点列表 */
    async getDeliveryList() {
      try {
        const res = await this.$api.delivery.deliverylist();
        this.arrList = res.data;
        if (this.arrList.length > 0) {
          this.from.delivery_id = this.arrList[0].id;
        }
      } catch (error) {
        console.log(error, "deliverylist===");
      }
    },
    /* 搜索 */
    search() {
      this.from.page = 1;
      this.tableData = [];
      this.hqlist();
    },
    /* 导出 */
    async exportHandle() {
      this.disabledExport = true;
      this.$message.success("正在导出，请耐心等待");
      try {
        const params = {
          ...this.from,
        };
        delete params.page;
        delete params.pageSize;
        const res = await getTakeOrderPlacenoExport(params);
        if (res instanceof Blob && res.type === "application/json") {
          const data = JSON.parse(await res.text());
          this.$message.error(data.msg || "导出失败了");
          return;
        }else{
          downLoadFlowBlob(res, res?.filename);
          this.$message.success("导出成功");
        }
      } catch (err) {
        this.$message.error("导出失败了");
        console.log("ajax getTakeOrderPlacenoExport err", err);
      } finally {
        this.disabledExport = false;
      }
    },
    /* 重置 */
    async resettingHandle() {
      try {
        const res = await postTakeOrderPlacenoReset({
          supply_time: this.from.supply_time,
          delivery_id: this.from.delivery_id,
        });
        this.from.page = 1;
        this.tableData = [];
        this.hqlist();
      } catch (error) {
        console.log(error, "postTakeOrderPlacenoReset");
      }
    },
    Refresh() {
      this.from = {
        ...this.formDataClone,
      };
      this.from.page = 1;
      this.tableData = [];
      this.hqlist();
    },
    /** 页码发生改变 */
    handleSizeChange(val) {
      this.from.pageSize = val;
      this.hqlist();
    },
    /** 页数发生改变 */
    handleCurrentChange(val) {
      this.from.page = val;
      this.hqlist();
    },
    /** 修改备注 ｜坑位 成功 刷新列表 */
    submit() {
      this.from.page = 1;
      this.tableData = [];
      this.hqlist();
    },
    /** 列表数据 */
    async hqlist() {
      this.loading = true;
      let params = this.tool.DeepCopy({}, this.from);
      if (this.role == "delivery" && params.hasOwnProperty("delivery_id")) {
        delete params.delivery_id;
      }
      params.datatype = 1; // 1列表数据
      try {
        const res = await postTakeOrderPlacenoList(params);
        this.tableData = res.data.list;
        this.total = res.data.total;
      } catch (error) {
        console.log(error, "postTakeOrderPlacenoList");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.Receiving {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  /deep/ .el-table .el-table__cell {
    padding: 5px 0px !important;
  }
  .title {
    background: #ffffff;
    padding: 13px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;

    .left-actions {
      // display: flex;
      flex-direction: column;
      margin-right: 8px;
    }
    .top-buttons {
      display: flex;
      align-items: center;
    }

    .seach {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      flex-wrap: wrap;

      .itemInput {
        width: 150px;
        margin-right: 8px;
        margin-bottom: 8px;
      }
      .itemInput1 {
        margin-right: 8px;
        margin-bottom: 8px;
      }
      .btnWrap {
        margin-bottom: 8px;
      }
    }

    .bjsearch {
      background: #333333;
      border-color: #333333;
    }
  }
  .tips {
    color: red;
    font-size: 12px;
    margin-top: 20px;
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>